import { getLinearSettings } from "../../helper.ts";
import type { ChartStyleSettings } from "../../../../../../../../../api/types/svTypes.ts";

export function isShowArgumentLabel(settings: ChartStyleSettings) {
  return getLinearSettings(settings)?.argumentAxis?.showLabel !== false;
}
